import MuiStepLabel from "@mui/material/StepLabel";
const StepLabel = MuiStepLabel;
export default StepLabel;
